import React from "react";
import {
  colorTokens,
  getSpacing,
  typographyTokens,
} from "../../../designTokens";
import dropdownIcon from "../../../Assets/icons/dropDownIcon.svg";

export interface ExpandableGroupToggleProps {
  extraCount: number;
  isExpanded: boolean;
  onToggle: () => void;
  id?: string;
  expandAriaLabel?: string;
  collapseAriaLabel?: string;
}

const ExpandableGroupToggle: React.FC<ExpandableGroupToggleProps> = ({
  extraCount,
  isExpanded,
  onToggle,
  id,
  expandAriaLabel = "Expand group",
  collapseAriaLabel = "Collapse group",
}) => (
  <button
    type="button"
    aria-label={isExpanded ? collapseAriaLabel : expandAriaLabel}
    aria-expanded={isExpanded}
    onClick={(e) => {
      e.stopPropagation();
      onToggle();
    }}
    style={{
      height: getSpacing("24px"),
      minHeight: getSpacing("24px"),
      border: "none",
      backgroundColor: "transparent",
      display: "inline-flex",
      alignItems: "center",
      justifyContent: "center",
      cursor: "pointer",
      flexShrink: 0,
      padding: 0,
    }}
    id={id}
  >
    <div style={{ display: "inline-flex", alignItems: "center" }}>
      {extraCount > 0 ? (
        <span
          style={{
            display: "inline-flex",
            alignItems: "center",
            justifyContent: "center",
            fontFamily: typographyTokens["Body/Small"].family,
            fontSize: `${typographyTokens["Body/Small"].size}px`,
            fontWeight: typographyTokens["Body/Small"].weight,
            backgroundColor: colorTokens["Background/Greyish"],
            color: colorTokens["Text/Light Grey"],
            padding: `${getSpacing("2px")} ${getSpacing("4px")} ${getSpacing("2px")} ${getSpacing("8px")}`,
            borderRadius: "999px",
            whiteSpace: "nowrap",
            lineHeight: 1,
          }}
        >
          +{extraCount}
          <img
            src={dropdownIcon}
            alt=""
            aria-hidden="true"
            style={{
              width: "16px",
              height: "16px",
              marginLeft: getSpacing("4px"),
              transform: isExpanded ? "rotate(180deg)" : "rotate(0deg)",
              transition: "transform 0.15s ease",
            }}
          />
        </span>
      ) : null}
      <img
        src={dropdownIcon}
        alt=""
        aria-hidden="true"
        style={{
          width: "16px",
          height: "16px",
          ...(extraCount > 0 ? { display: "none" } : {}),
          transform: isExpanded ? "rotate(180deg)" : "rotate(0deg)",
          transition: "transform 0.15s ease",
        }}
      />
    </div>
  </button>
);

export default ExpandableGroupToggle;
